import OrgonogramImage from "../../../assets/images/about/orgonogram.png";
import OurTeamHero from "../../../assets/images/about/our-team-hero.png";
import MdImg from "../../../assets/images/about/md.png";

import PriceQualityShipmentLeftImg from "../../../assets/images/about/left.png";
import PriceQualityShipmentMiddleImg from "../../../assets/images/about/middle.png";
import PriceQualityShipmentRightImg from "../../../assets/images/about/right.png";
import PeopleIcon from "../../../assets/images/about/people-icon.png";
import OkIcon from "../../../assets/images/about/ok-icon.png";

import ProcessQualityImage from "../../../assets/images/about/process-quality.png";
import DesignDevelopmentImage from "../../../assets/images/about/design-development.png";
import LeadTimeImage from "../../../assets/images/about/lead-time.png";
import ERPImage from "../../../assets/images/about/erp.png";

export const heroOurTeamImage = OurTeamHero;
export const organogramImage = OrgonogramImage;

// MessageMD
export const MDImage = MdImg;

// PriceQualityShipment
export const PriceQualityShipmentLeftImage = PriceQualityShipmentLeftImg;
export const PriceQualityShipmentMiddleImage = PriceQualityShipmentMiddleImg;
export const PriceQualityShipmentRightImage = PriceQualityShipmentRightImg;

export const PriceQualityShipmentPonits = [
  {
    image: PeopleIcon,
    alt: "People",
    text: "Minimum order quantity is 2,000 pieces per color, per style",
  },
  {
    image: OkIcon,
    alt: "Ok",
    text: "Transactions are guaranteed safe",
  },
];

// SixthSection - OurTeam

export const SixthSectionCards = [
  {
    img: ProcessQualityImage,
    title: "Process & Quality",
    description:
      "A strict regime of internal audits, critical process check, 3rd party testing on fabric / accessories / garments and Pre-final Inspection @ AQL 2.5 are done prior to shipment.",
  },
  {
    img: DesignDevelopmentImage,
    title: "Design & Development",
    description:
      "We can assist customer creating fits and design for garments. We offer choices of fabrication, wide range of accessories and different packaging method: flat pack, boxed pack, hanging garments, etc.",
  },
  {
    img: LeadTimeImage,
    title: "Lead Time",
    description:
      "90 days from fabric approval (imported fabric by sea shipment)- 120 days from fabric / print design or color selection (imported fabric by sea shipment).",
  },
  {
    img: ERPImage,
    title: "ERP (Enterprise Resource Planning)",
    description:
      "Our core functions are based on Enterprise Resource Planning (ERP). We strive continuously to reduce wastage of materials and increase production efficiency.",
  },
];
